// src/store/useStore.js
import { create } from 'zustand';

const useStore = create((set) => ({
  // Auth state
  user: null,
  isAuthenticated: false,
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  logout: () => set({ user: null, isAuthenticated: false }),

  // Theme state
  theme: localStorage.getItem('theme') || 'dark',
  toggleTheme: () => set((state) => {
    const newTheme = state.theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem('theme', newTheme);
    if (newTheme === 'light') {
      document.documentElement.classList.add('light');
    } else {
      document.documentElement.classList.remove('light');
    }
    return { theme: newTheme };
  }),

  // UI state — closed by default on mobile (< lg breakpoint), open on desktop,
  // since the sidebar renders as a full-screen overlay drawer below lg.
  sidebarOpen: typeof window !== 'undefined' ? window.innerWidth >= 1024 : true,
  setSidebarOpen: (val) => set({ sidebarOpen: val }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  // Connector switcher — incrementing this key forces all pages to remount
  // and re-read connector config from the newly active profile.
  connectorKey: 0,
  incrementConnectorKey: () => set((state) => ({ connectorKey: state.connectorKey + 1 })),

  // Controls the "Add another connector" form opened from the Header
  connectorFormOpen: false,
  setConnectorFormOpen: (v) => set({ connectorFormOpen: v }),
  
  // Notifications
  notifications: [],
  addNotification: (notification) => set((state) => ({
    notifications: [...state.notifications, { ...notification, id: Date.now(), timestamp: Date.now() }]
  })),
  removeNotification: (id) => set((state) => ({
    notifications: state.notifications.filter(n => n.id !== id)
  })),

  // Assets
  assets: [],
  selectedAsset: null,
  setAssets: (assets) => set({ assets }),
  setSelectedAsset: (asset) => set({ selectedAsset: asset }),
  
  // Policies
  policies: [],
  setPolicies: (policies) => set({ policies }),
  
  // Jobs
  jobs: [],
  setJobs: (jobs) => set({ jobs }),
  
  // Transfers
  transfers: [],
  setTransfers: (transfers) => set({ transfers }),
  
  // Loading states
  loading: {
    assets: false,
    policies: false,
    jobs: false,
    transfers: false,
  },
  setLoading: (key, value) => set((state) => ({
    loading: { ...state.loading, [key]: value }
  })),
}));

export default useStore;